import { Component, Input, OnInit } from '@angular/core';

import { GuildsService } from 'src/app/core/api/services';
import { BaseSelectSearch } from './base/base-select-search.component';
import { BaseSelectSearchModule } from './base/base-select.search.module';

@Component({
    selector: 'business-group-select-search',
    templateUrl: './base/base-select-search-template.html',
    imports: [BaseSelectSearchModule]
})
export class BusinessGroupsSelectSearchComponent
  extends BaseSelectSearch
  implements OnInit
{
  @Input('fieldName') input_fieldName: any;

  constructor(protected currentService: GuildsService) {
    super();
  }

  initConfig() {
    super.initConfig();
    if (!this.label) this.label = 'common.airports';
  }

  getItemsApi() {
    if (this.input_fieldName == 'subGuild' && this.id == null) {
      this.initLoading = false;
      this.isFetchData = true;
      return;
    }

    if (!this.id && this.id != null) {
      this.initLoading = false;
      this.isFetchData = true;
      return;
    }

    let searchId = this.id;
    //first level
    if (this.id === 'null') {
      this.id = null;
      searchId = null;
    }
    if (this.id == 0) searchId = null;

    this.currentService
      .guildsGetGuildsByParentIdList({ ParentId: searchId })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }
}
